import { z } from 'zod';
import { paginationFiltersSchema, sortFiltersSchema } from 'utils/schemas';
import {
  contentReviewEntityTypes,
  contentReviewStatuses,
} from './admin-content-reviews.types';

export const adminContentReviewsFiltersSchema = z
  .object({
    status: z.array(z.enum(contentReviewStatuses)).catch(['pending']),
    entityType: z.array(z.enum(contentReviewEntityTypes)).catch([]),
    liveEntityId: z.string().catch(''),
    search: z.string().catch(''),
  })
  .merge(sortFiltersSchema)
  .merge(paginationFiltersSchema);
